<template>
  <div class="zt-progress-bar justify-center w-full text-center">
    <div class="relative justify-start flex w-24 m-auto">
      <div class="absolute top left justify-start flex">
        <div
          v-for="bg in generateBgItems"
          :key="bg"
          class="w-4 h-1 py-1 mx-1 relative bg-zt-dark-200 rounded"
        ></div>
      </div>
      <div
        v-for="item in percentPartActive"
        :key="item"
        class="outer-part w-4 h-1 rounded mx-1 py-1 relative"
        :class="[colorPercentStatus]"
      ></div>
    </div>
    <slot />
  </div>
</template>

<script>
import {divide, filter, gte, map, range} from 'lodash'

export default {
  name: 'ztProgressBar',
  props: {
    percent: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      generateBgItems: 4
    }
  },
  computed: {
    colorPercentStatus() {
      if (this.percent > 0 && this.percent <= 25) {
        return 'bg-zt-danger'
      }
      if (this.percent > 25 && this.percent <= 75) {
        return 'bg-zt-warning'
      }
      if (this.percent > 75 && this.percent < 100) {
        return 'bg-zt-warning'
      }
      if (this.percent === 100) {
        return 'bg-zt-success'
      }
      return null
    },
    percentPartActive() {
      if (this.percent < 25) {
        return [0]
      }
      return filter(this.calculateRange(0, 25, 100), value => gte(value, this.percent))
    }
  },
  methods: {
    calculateRange(start, block, limit) {
      return map(
        n => start + block * (n + 1),
        range(0, divide(limit - start, block))
      );
    }
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../styles/components/ztProgressBar.css"
/>
